import React, { useEffect, useRef, useState } from "react";
import { Link } from "gatsby";
import clsx from "clsx";
import PubSub from "pubsub-js";
import CountDown from "../ui/CountDown";
import styled from "styled-components";
import SanityImage from "../SanityImage";
// import { StaticImage } from "gatsby-plugin-image";

import motifFooterCountdown from "../../images/motif-footer-countdown.svg";
import motifDamier from "../../images/motif-damier.svg";
import carreDamier from "../../images/carre-damier.svg";
import carreCercle from "../../images/carre-cercle.svg";
import nuancierGrisLong from "../../images/nuancier-gris-long.svg";
import nuancierGrisCourt from "../../images/nuancier-gris-court.svg";
// import close from "../../images/close.svg";

const Wrapper = styled.div`
  width: var(--col-6-13);
  top: var(--headerHeight);
  z-index: 1;
  // opacity: 0;
  transform: translateY(-101%);
  .collapsible {
    overflow: hidden;
    // max-height: 0;
  }
  &.is-collapsed {
    // .collapsible {
    //   display: none;
    // }
    .button svg {
      transform: rotate(45deg);
    }
  }
  .countdown {
    max-height: 0.75em;
    line-height: 0.8;
    font-size: 4.9vw;
    @media all and (max-width: 1080px) {
      font-size: 95px;
      font-size: 71px;
    }
  }
  .cartouche-text {
    transform: translateY(3px);
  }
  @media all and (max-width: 1080px) {
    &.is-collapsed {
      .order-2 {
        height: 0;
      }
    }
    &.is-collapsed .collapsible,
    &.is-collapsed .sm\:collapsible {
      display: none;
    }
    width: 100%;
    .w-90 {
      width: 90%;
    }
    .w-60 {
      width: 60%;
    }
    .w-30 {
      width: 30%;
    }
    .w-10 {
      width: 10%;
    }
  }
`;

const Button = styled.button`
  background: white;
  max-width: 40px;
  border: none;
  appearance: none;
  border: 1px solid;
  padding: 0 0.2em;
  height: 20px;
  line-height: 20px;
  text-align: center;
  &:hover {
    svg path {
      fill: white;
    }
  }
  svg {
    margin: 0 auto;
  }
`;
const ProductDrop = ({ input }) => {
  // console.log(input);
  const { slug, images, productDrop } = input;
  const { title: productDropTitle, infos, dropDate } = productDrop;

  const [collapsed, setCollapsed] = useState(false);
  const [hide, setHide] = useState(false);
  const [rendered, setRendered] = useState(false);

  const wrapperRef = useRef();

  let timing = {
    duration: 400,
    easing: "ease", // easing function
    fill: "forwards", // animation fill mode
  };

  useEffect(() => {
    setTimeout(() => {
      _format();
    }, 150);

    window.addEventListener("resize", _format);

    return () => window.removeEventListener("resize", _format);
  }, [collapsed]);

  const _format = () => {
    if (collapsed) return;
    if (rendered) return;

    const collapsibles = document.querySelectorAll(".collapsible");
    collapsibles.forEach((el, i) => {
      const { height } = el.getBoundingClientRect();
      el.dataset.height = height;
      el.dataset.delay = (collapsibles.length - i) * 50;
    });

    setRendered(true);
  };

  useEffect(() => {
    const keyframes = [
      { transform: "translateY(-101%)", opacity: 0 },
      { transform: "translateY(0)", opacity: 1 },
    ];
    wrapperRef.current.animate(keyframes, timing);
  }, [rendered]);

  useEffect(() => {
    // console.log(collapsed);
    if (!rendered) return;

    if (collapsed) {
      animeOut();
    } else {
      animeIn();
    }
  }, [collapsed]);

  const animeOut = () => {
    document.querySelectorAll(".collapsible").forEach((el, i) => {
      const { height, delay } = el.dataset;
      timing.delay = delay;
      const keyframes = [{ maxHeight: height + "px" }, { maxHeight: 0 }];

      el.animate(keyframes, timing);
    });
  };
  const animeIn = () => {
    document.querySelectorAll(".collapsible").forEach((el) => {
      const { height, delay } = el.dataset;
      timing.delay = delay;
      const keyframes = [{ maxHeight: 0 }, { maxHeight: height + "px" }];
      el.animate(keyframes, timing);
    });
  };

  const _onEnd = () => {
    setHide(true);
    PubSub.publish("COUNDOWN_END");
  };

  return (
    <Wrapper
      ref={wrapperRef}
      className={clsx(
        "product-drop absolute left-0 ",
        hide ? "hidden" : "",
        collapsed ? "is-collapsed" : ""
      )}>
      <div className='flex flex-wrap md:flex-nowrap'>
        <div className='group w-60 md:w-4/12 order-3 md:order-1 flex-shrink-0'>
          <div className='collapsible'>
            {/* <Link to={`/product/${slug.current}`}> */}
            <div className='filter grayscale bg-gray-100'>
              <SanityImage input={{ image: images[0] }} />
            </div>
            <div className='bg-key text-white'>{productDropTitle}</div>
            {/* </Link> */}
          </div>
        </div>

        <div className='group w-90 md:w-6/12 order-1 md:order-2 flex-shrink-0'>
          <div className='collapsible'>
            <div className='bg-key text-white text-center'>
              <CountDown end={dropDate} callback={_onEnd} />
            </div>
            <div
              className='bg-gray-100 '
              style={{
                height: 0,
                paddingTop: `${(22 / 660) * 100}%`,
              }}>
              <img
                src={motifFooterCountdown}
                alt=''
                className='w-full h-full absolute top-0 left-0'
              />
            </div>
          </div>
          <div className='infos'>
            <div className='flex items-start'>
              <div className='w-4/12  '>
                <div className='bg-gray-100 pt-sm collapsible'>
                  {/* <div className='cartouche-text'>Collaboration</div> */}
                </div>
              </div>
              <div className='w-8/12'>
                <div className='bg-gray-100 pt-sm collapsible '>
                  <div className='cartouche-text'>{infos}</div>
                </div>
                <div
                  className='bg-gray-100 sm:collapsible'
                  style={{
                    height: 0,
                    paddingTop: `${(20 / 400) * 100}%`,
                  }}>
                  <img
                    src={motifDamier}
                    alt=''
                    className='w-full h-full absolute top-0 left-0'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='group w-30 md:w-2/12 order-3 flex-shrink-0'>
          <div className='collapsible'>
            <div className='w-4/12'>
              <img src={carreDamier} alt='' className='hidden-sm' />
            </div>
            <div className='pl-2/6'>
              <img src={carreCercle} alt='' className='w-full' />
            </div>
          </div>
          <div className='product-title bg-key text-white  pt-md text-sm'>
            <div className='cartouche-text uppercase'>Who Got Next ?</div>
          </div>
          <div className='nuancer'>
            <img src={nuancierGrisLong} alt='' className='w-full' />
            <div className='absolute top-0 -left-sm'>
              <img src={nuancierGrisCourt} alt='' className='' />
            </div>
          </div>
          <div className='flex justify-end'>
            <Button
              onClick={() => setCollapsed(!collapsed)}
              className='button'
              aria-label='close'>
              <svg
                className='pen'
                width='8'
                height='8'
                viewBox='0 0 8 8'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M1.99005 4.47005L0.0700684 2.55005L1.63007 0.990051L3.55005 2.91005L5.47003 0.990051L7.04004 2.55005L5.12006 4.47005L7.04004 6.39005L5.47003 7.96005L3.55005 6.04005L1.63007 7.96005L0.0700684 6.39005L1.99005 4.47005Z'
                  fill='black'
                />
              </svg>
            </Button>
          </div>
        </div>
        <div className='group order-2 sm-only w-10 flex-shrink-0'>
          <img src={carreDamier} alt='' className='w-full' />
        </div>
      </div>
    </Wrapper>
  );
};

export default ProductDrop;
